"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getResize = function (resize) {
    if (resize === 'horizontal') {
        return 'horizontal';
    }
    if (resize === 'vertical') {
        return 'vertical';
    }
    if (resize === 'none') {
        return 'none';
    }
    if (resize) {
        return 'both';
    }
    return 'vertical';
};
exports.default = (function (_a) {
    var resize = _a.resize;
    return "resize: " + getResize(resize) + ";";
});
